import { Button } from '@/global/components/Button'
import Grid from '@/global/components/ui/Grid'
import dayjs from 'dayjs'
import { FormDatePicker } from 'global/components/Form'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { centroCustoFuncionario_api, funcionario } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { AdicionarCentroCusto } from 'templates/Cadastro/CentroCusto/atoms/modals/Adicionar'
import { FuncionarioCentroCustoDataGrid } from './Datagrid'

export const CentroCustoForm: React.FC = () => {
    const { pathname } = useLocation()
    const { watch, setError, clearErrors, setValue } = useFormContext()

    const adicionar = pathname.endsWith('adicionar')

    const funcionarioId = useStore(state => state.employeeId)
    const { mutateAsync } = centroCustoFuncionario_api.mutations.useCreate({
        onSuccess: async () => {
            toast.success('Centro de custo adicionado com sucesso')
            await Promise.all([
                centroCustoFuncionario_api.invalidateQueries(),
                funcionario.invalidateQueries(),
            ])
        },
        onError: ({ message }) => {
            toast.error(message)
        },
    })

    const indeterminado = watch('indeterminado')
    const centroCusto = watch('FuncionarioCentroCusto.CentroCusto')
    const dtInicial = watch('FuncionarioCentroCusto.dtInicial')
    const dtFinal = watch('FuncionarioCentroCusto.dtFinal')

    async function handleClick() {
        if (!dtInicial) {
            setError('FuncionarioCentroCusto.dtInicial', {
                type: 'required',
                message: 'Campo obrigatório',
            })
        } else {
            clearErrors('FuncionarioCentroCusto.dtInicial')

            await mutateAsync({
                centroCustoId: centroCusto.id,
                dtInicial: dayjs(dtInicial).toDate(),
                dtFinal: dtFinal ? dayjs(dtFinal).toDate() : null,
                funcionarioId,
            })
        }
    }

    useEffect(() => {
        if (indeterminado) {
            setValue('FuncionarioCentroCusto.dtFinal', undefined)
        }
    }, [indeterminado, setValue])

    return (
        <section
            id="centro-custo"
            onKeyDownCapture={e => e.stopPropagation()}
            className="mt-10"
        >
            <Grid container>
                <Grid item xs={12} className="-mt-10 inline-flex">
                    <AdicionarCentroCusto className="flex-1" />
                    {!adicionar && (
                        <Button
                            disabled={!centroCusto}
                            onClick={handleClick}
                            className="h-14 ml-2"
                        >
                            Inserir
                        </Button>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormDatePicker
                        name="FuncionarioCentroCusto.dtInicial"
                        label="Data inicial"
                        type="date"
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormDatePicker
                        name="FuncionarioCentroCusto.dtFinal"
                        label="Data final"
                        type="date"
                        helperText="Deixe em branco para indeterminado"
                    />
                </Grid>
                {!adicionar && (
                    <Grid item xs={12}>
                        <FuncionarioCentroCustoDataGrid />
                    </Grid>
                )}
            </Grid>
        </section>
    )
}
